export default {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
};



// WEBPACK FOOTER //
// ./V7/events/listing/calendarView/EventsCalendarViewMode.js